// Current manual access is independent from historical AI interaction credentials.
// Every entry uses this gate; target authorization remains authoritative on the server.
export function manualUnavailable({ blocked, busy, valid = true }) {
  return !!(blocked || busy || !valid);
}
